RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const setController = {
        action: function (curation) {
            curation.controller = curation.controller || new curation.StateMachine(curation.model);
        }
    };

    const setState = function (curation) {
        if (curation.controller.state !== curation.getProp('state')) {
            curation.executeTransition(curation.controller.state);
        }
    };

    const listenForTransition = function (curation) {
        curation.listenTo(curation.controller, 'transition', function (from, to) {
            curation.executeTransition(to);
        });
    };

    models.Wizard = Marionette.Dashboard.models.Model.mixin({
        initialize: function () {
            const me = this;
            App.models.Curation.prototype.initialize.apply(me, arguments);
            me.beforeFilters = (me.beforeFilters || []).concat([setController, setState, listenForTransition]);
        },

        executeTransition: function (state) {
            const me = this;

            if (state[0] === '/') {
                RivalIQ.execute('toggle:shell', true);
                return RivalIQ.execute('history:navigate', state, {
                    trigger: true,
                    doNotTrack: true
                });
            }

            me.setProps({
                state: state
            });
        },

        mixins: {
            filters: Marionette.Dashboard.mixins.Filters
        },

        navigate: _.noop,

        getWidgets: function () {
            const me = this;
            const View = me.attributes.views[me.getProp('state')].class;
            const view = new View(_.extend({}, me.attributes.views[me.getProp('state')].options, {
                model: me.model
            }));
            return view;
        },

        hasToolbar: function () {
            return false;
        },

        showViews: function (region, LayoutView, view, deferred) {
            const me = this;

            view.on('loading:finished', deferred.resolve);
            const View = me.View || App.views.View;
            region.show(new View({
                model: me.model,
                view: view
            }));
        }
    });

});
